export interface GoogleFontWithWeights {
  family: string;
  weights: Set<string>;
}

const buildWeightAxis = (weights: Iterable<string>): string => {
  const validWeights = Array.from(
    new Set(
      Array.from(weights, w => Number.parseInt(String(w), 10)).filter(
        n => Number.isInteger(n) && n >= 100 && n <= 900 && n % 100 === 0,
      ),
    ),
  ).sort((a, b) => a - b);

  if (validWeights.length === 0) return "";

  const isFullRange =
    validWeights.length === 9 &&
    validWeights[0] === 100 &&
    validWeights[8] === 900;
  return isFullRange ? "wght@100..900" : `wght@${validWeights.join(";")}`;
};

const generatePreloadLinks = (
  fonts: Map<string, GoogleFontWithWeights>,
): string => {
  const preloadLinks: string[] = [];

  for (const { family, weights } of fonts.values()) {
    const name = family.trim();
    if (!name) continue;

    const axis = buildWeightAxis(weights);
    const familyParam = axis ? `${name}:${axis}` : name;

    const fontUrl = `https://fonts.googleapis.com/css2?family=${familyParam}&display=swap`;

    // Preload the CSS file with immediate loading to prevent FOUC
    preloadLinks.push(
      `<link rel="preload" href="${fontUrl}" as="style" onload="this.onload=null;this.rel='stylesheet'">`,
      `<noscript><link rel="stylesheet" href="${fontUrl}"></noscript>`,
    );
  }

  return preloadLinks.join("\n");
};

export const generateGoogleFontsLinks = (
  fonts: Map<string, GoogleFontWithWeights>,
): string => {
  if (!fonts || fonts.size === 0) return "";

  const preloadLinks = generatePreloadLinks(fonts);

  return `
  <link rel="preconnect" href="https://fonts.googleapis.com">
  <link rel="preconnect" href="https://fonts.gstatic.com" crossorigin>
  ${preloadLinks}`.trim();
};
